import React, { Fragment, useState } from 'react';
import { useUser } from '../../context/UserContext';
import UserForm from './UserForm';
import '../admin/AdminComponents.css';

const UsersManagement = () => {
  const { users, roles, deleteUser } = useUser();
  const [editingUser, setEditingUser] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [expandedUserId, setExpandedUserId] = useState(null);

  const handleEdit = (user) => {
    setEditingUser(user);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this user?')) {
      try {
        await deleteUser(id);
      } catch (error) {
        alert(error.message || 'Failed to delete user');
      }
    }
  };

  const handleFormClose = () => {
    setShowForm(false);
    setEditingUser(null);
  };

  const toggleCharacters = (userId) => {
    setExpandedUserId((currentId) => currentId === userId ? null : userId);
  };

  const getUserRoleName = (user) => {
    if (user.role_name) {
      return user.role_name;
    }
    if (user.roleId) {
      const role = roles.find(r => r.id === user.roleId);
      return role ? role.name : 'Unknown';
    }
    if (user.role_id) {
      const role = roles.find(r => r.id === user.role_id);
      return role ? role.name : 'Unknown';
    }
    return 'Unknown';
  };

  return (
    <div className="admin-section">
      <div className="admin-section-header">
        <h2 className="admin-section-title">OAuth Users Management</h2>
        <div className="admin-section-actions">
          <p style={{ fontSize: '0.9rem', color: 'var(--text-secondary)', marginRight: '1rem' }}>
            OAuth users are created automatically when they log in via GTA World. You can only edit their roles.
          </p>
        </div>
      </div>
      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Username (UCP)</th>
              <th>ID</th>
              <th>Role</th>
              <th>Created</th>
              <th>Character(s)</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => {
              const characters = user.characters || [];
              const isExpanded = expandedUserId === user.id;

              return (
                <Fragment key={user.id}>
                  <tr>
                    <td>{user.username}</td>
                    <td>#{user.gtaWorldUserId || '-'}</td>
                    <td>{getUserRoleName(user) || 'No Role'}</td>
                    <td>{user.createdAt ? new Date(user.createdAt).toLocaleDateString() : user.created_at ? new Date(user.created_at).toLocaleDateString() : '-'}</td>
                    <td>
                      <button
                        className="admin-character-toggle"
                        onClick={() => toggleCharacters(user.id)}
                        aria-expanded={isExpanded}
                      >
                        {isExpanded ? 'Hide Character(s)' : 'Show Character(s)'}
                      </button>
                    </td>
                    <td>
                      <div className="admin-table-actions">
                        <button
                          className="admin-icon-button"
                          onClick={() => handleEdit(user)}
                          title="Edit Role"
                        >
                          ✎
                        </button>
                        <button
                          className="admin-icon-button danger"
                          onClick={() => handleDelete(user.id)}
                          title="Delete"
                        >
                          ×
                        </button>
                      </div>
                    </td>
                  </tr>

                  {isExpanded && (
                    <tr className="admin-character-row">
                      <td colSpan="6">
                        {characters.length > 0 ? (
                          <div className="admin-character-list">
                            {characters.map((character) => (
                              <div className="admin-character-card" key={character.id}>
                                <div>
                                  <strong>{character.firstname} {character.lastname}</strong>
                                  {character.isActive && <span className="admin-character-active">Active</span>}
                                </div>
                                <div className="admin-character-meta">
                                  <span>ID: #{character.characterId || character.id}</span>
                                  {character.email && <span>Email: {character.email}</span>}
                                  {character.phone && <span>Phone: {character.phone}</span>}
                                  {character.city && <span>City: {character.city}</span>}
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="admin-character-empty">No characters found for this user.</div>
                        )}
                      </td>
                    </tr>
                  )}
                </Fragment>
              );
            })}
          </tbody>

        </table>

      </div>


      {showForm && (
        <UserForm
          user={editingUser}
          onClose={handleFormClose}
        />

      )}
    </div>

  );
};

export default UsersManagement;

